class IntegerDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    link(scope, elm, attrs, ctrl) {
        ctrl.$validators.integer = function(modelValue, viewValue) {
            if (ctrl.$isEmpty(modelValue)) {
                return true;
            }

            if (/^-?\d+$/.test(viewValue)) {
                return true;
            }

            return false;
        };
    }

    static directiveFactory() {
        'ngInject';
        return new IntegerDirective();
    }
}

export default IntegerDirective;
